<template>
  <div>
    <a-table
      :columns="configPayload.columns"
      :data-source="table_list"
      :rowKey="(record, index) => index"
      :pagination="false"
      :loading="table_loading"
    >
      <template
        v-for="column in configPayload.columns"
        :slot="column.scopedSlots ? column.scopedSlots.customRender : ''"
        slot-scope="text, record"
      >
        <slot
          :name="column.scopedSlots ? column.scopedSlots.customRender : ''"
          v-bind="record"
        ></slot>
      </template>
    </a-table>
    <!-- 分页配置 -->
    <base-pagination
      :currentPage="pagination.current"
      :pageSize="pagination.page_size"
      :total="pagination.total"
      @onChange="onChange"
      @onShowSizeChange="onChange"
    >
    </base-pagination>
  </div>
</template>
<script>
export default {
  props: {
    configPayload: {
      type: Object,
      required: true,
    },
    selectValue: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      table_list: [],
      table_loading: false,
      pagination: {
        current: 1,
        page_size: 10,
        total: 0,
      },
    };
  },
  mounted() {
    this.getTableList(1, 10);
  },

  methods: {
    //   获取table 列表信息
    getTableList(current, page_size) {
      let select_value = JSON.parse(JSON.stringify(this.selectValue));
      let payload = {
          current,
          page_size,
          ...select_value,
      };
      this.table_loading = true;
      this.configPayload
        .http_api(payload)
        .then((res) => {
          if (res.code == 200) {
            const { list, pagination } = res.data;
            this.table_list = list;

            this.pagination = {
              current: pagination.current,
              page_size: pagination.page_size,
              total: pagination.total,
            };
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.table_loading = false;
        });
    },
    // 分页事件-修改当前页码、修改当前页数
    onChange(current, page_size) {
      this.getTableList(current, page_size);
    },
  },
};
</script>
